import { useMemo } from 'react';
import { ImageCard } from 'src/types';
import { prepareGeneratedImages } from 'src/utils';
import { ImageGenData } from 'src/types/models/ImageGenData';
import { useUserMetadata } from '../userSettingsHooks';
import { useGetUser } from '../userHooks';

export const useConversationImages = (imageCard: ImageCard) => {
  const { images, watermarked_images } = imageCard;
  const { tierId, isOpenTier, isFreeTier } = useGetUser();
  const { metadata } = useUserMetadata();

  const isLimitedEditing = useMemo(
    () => !!watermarked_images && (isOpenTier || isFreeTier),
    [watermarked_images, isOpenTier, isFreeTier],
  );

  const imagesArray = useMemo(() => {
    if (isLimitedEditing && watermarked_images) {
      // TODO(olha): it's a temporary workaround until BE returns proper model in response
      const imagesWithModels = Object.entries(watermarked_images).reduce(
        (acc, [key, item]) => {
          acc[key] = {
            ...item,
            model: 'alias/ninjatech/ninja-pix',
          };
          return acc;
        },
        {} as Record<string, ImageGenData>,
      );
      return prepareGeneratedImages({
        images: imagesWithModels,
        tierId,
        withWatermark: true,
        metadata,
      });
    }
    if (!!images) {
      return prepareGeneratedImages({
        images,
        tierId,
        metadata,
      });
    }
    return [];
  }, [images, watermarked_images, tierId, isLimitedEditing, metadata]);

  return imagesArray;
};
